<template lang="pug">
    v-card.summary(
        elevation="0"
    )
        v-card-title.text-medium.d-flex.flex-row.justify-space-between.align-center.mx-2
            span.volie-color-blue Summary
            span.font-weight-bold.text-uppercase(
                :class="enrollerRun.status | statusClassMatcher"
            ) {{ enrollerRun.status || '---' }}
        v-card-text.ma-2
            v-row.pb-2
                v-col(cols="6")
                    v-row
                        v-col(cols="12")
                            .text-uppercase.text-small Created At
                            .text-black {{ enrollerRun.friendly_created_at_date || '---' }}
                    v-row
                        v-col(cols="12")
                            .text-uppercase.text-small Completed At
                            .text-black {{ enrollerRun.friendly_completed_at || '---' }}
                    v-row
                        v-col(cols="12")
                            .text-uppercase.text-small Step
                            .text-black {{ enrollerRunComplete ? '---' : enrollerRun.step }}
                    v-row
                        v-col(cols="12")
                            .text-uppercase.text-small Duration
                            .text-black {{ enrollerRun.duration | friendlyMillisecondFormat }}
                v-col(cols="6")
                    v-row
                        v-col(cols="12")
                            .text-uppercase.text-small Query Param Customers
                            .text-black {{ enrollerRun.total_enroller_run_criterion_customers || '0' | number }}
                    v-row
                        v-col(cols="12")
                            .text-uppercase.text-small Potential Customers
                            .text-black {{ enrollerRun.total_enroller_run_customers || '0' | number }}
                    v-row
                        v-col(cols="12")
                            .text-uppercase.text-small Eligible Customers
                            .text-black {{ enrollerRun.total_enroller_run_customers_valid || '0' | number }}
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    data() {
        return {

        }
    },
    props: {
        enrollerRun: Object,
        enrollerRunComplete: Boolean,
        enrollerRunError: Boolean,
    },
})
</script>

<style lang="scss" scoped>
    .summary {
        border-radius: 10px;
        background-color: var(--off-white);
        width: 100%;
    }
</style>